module.exports = __webpack_public_path__ + "static/img/logo_top_black.5f4211a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/logo_top_black.svg
// module id = cwW9
// module chunks = 5